var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"drawer":false}},[_c('template',{slot:"nav"},[_c('v-tabs',[_c('v-tab',[_vm._v("Viewers Map check")])],1)],1),_c('template',{slot:"content"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-card',{attrs:{"fluid":""}},[_c('ViewersMapChecker')],1)],1)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }